import { render } from "./CornSticksSlider.vue?vue&type=template&id=99c53714&scoped=true"
import script from "./CornSticksSlider.vue?vue&type=script&lang=js"
export * from "./CornSticksSlider.vue?vue&type=script&lang=js"

import "./CornSticksSlider.vue?vue&type=style&index=0&id=99c53714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c53714"]])

export default __exports__